import { pusher_channel } from "@/plugins/pusher";
import httpClient from "@/core/axios";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        form: {},
        state: null,
        schema: {},
        formErrors: null,
        formResponse: null,
        timeoutPtr: null
    },
    getters: {
        form(state) {
            return state.form;
        },
        state(state) {
            return state.state;
        },
        schema(state) {
            return state.schema;
        },
        formErrors(state) {
            return state.formErrors;
        },
        formResponse(state) {
            return state.formResponse;
        }
    },
    actions: {
        async fetch({ commit, state }, slug) {
            commit("setState", "form_rendered");

            pusher_channel.unbind("form.async_response_received");
            pusher_channel.bind("form.async_response_received", data => {
                clearTimeout(state.timeoutPtr);
                commit("setState", "async_response_received");
                commit("setFormResponse", data);
            });
            return httpClient
                .get(`/api/guest/app/:app_uuid/forms/${slug}`)
                .then(data => commit("setForm", data));
        },
        async submit({ commit, state }, payload) {
            commit("setState", "form_submitted");
            commit("setFormErrors", null);

            if (state.form.two_way_enabled) {
                commit(
                    "setTimeoutPtr",
                    setTimeout(() => {
                        commit("setFormResponse", {
                            message: state.form.async_pipe_timeout_message
                        });
                        commit("setState", "async_response_timeout");
                    }, state.form.timeout * 1000 + 1000)
                );
            }


            return httpClient
                .post(
                    `/api/guest/app/:app_uuid/forms/${payload.slug}/submit`,
                    payload.data,
                    { timeout: state.form.timeout * 1000 }
                )
                .then(data => {
                    commit("setFormResponse", data);
                    if (state.form.behavior === "sync") {
                        commit("setState", "response_received");
                    } else {
                        commit("setState", "async_waiting_response");
                    }

                    return Promise.resolve(data);
                })
                .catch(error => {
                    // let be this number here, this is invalid, but formulate pass it, i need it to test this part of code
                    // +1 (649) 178-2363
                    if (error.response.status === 422) {
                        clearTimeout(state.timeoutPtr);
                        commit("setState", "user_error");
                        commit("setFormErrors", error.response.data.errors);
                    } else if (error.code === "ECONNABORTED") {
                        commit("setState", "server_timeout");
                    } else {
                        return Promise.reject(error);
                    }
                });
        }
    },
    mutations: {
        setForm(state, data) {
            state.form = data;
            state.schema = [];

            const helper = state.form.fields.reduce(
                (h, o) => ((h[o.id] = Object.assign({}, o)), h),
                Object.create(null)
            );

            // temp solution, remove checkboxes without options, needs to be fixed
            state.form.fields.filter(f => !f.hidden);

            const tree = state.form.fields
                .filter(f => !f.hidden) // temp solution, described above
                .sort((a, b) => a.sort_order - b.sort_order)
                .reduce((t, node) => {
                    const current = helper[node.id];

                    if (!current.parent_id) {
                        // if it doesn't have a parent push to root
                        t.push(current);
                    } else {
                        helper[node.parent_id].children =
                            helper[node.parent_id].children || [];
                        helper[node.parent_id].children.push(current);
                    }

                    return t;
                }, []);

            tree.forEach(field => {
                state.schema[field.step || 0] =
                    state.schema[field.step || 0] || [];

                state.schema[field.step || 0].push(field);
            });
        },
        setState(state, data) {
            state.state = data;
        },
        setFormErrors(state, data) {
            state.formErrors = data;
        },
        setFormResponse(state, data) {
            if (data.redirect_url !== undefined) {
                window.open(data.redirect_url, "_blank");
            }
            state.formResponse = data;
            state.state = "response_rendered";
        },
        setTimeoutPtr(state, data) {
            state.timeoutPtr = data;
        },
        resetError(state, data) {
            Vue.delete(state.formErrors, data);
        }
    }
};
